//#region ../../node_modules/.pnpm/@mui+material@7.1.0_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+_8c76256369110b2505f132f86162c9a6/node_modules/@mui/material/esm/colors/grey.js
var e = {
	50: "#fafafa",
	100: "#f5f5f5",
	200: "#eeeeee",
	300: "#e0e0e0",
	400: "#bdbdbd",
	500: "#9e9e9e",
	600: "#757575",
	700: "#616161",
	800: "#424242",
	900: "#212121",
	A100: "#f5f5f5",
	A200: "#eeeeee",
	A400: "#bdbdbd",
	A700: "#616161"
};
//#endregion
export { e as default };

//# sourceMappingURL=index82.js.map